<template>
  <!-- _________________________ RESET PASSWORD _________________________ -->
  <div id="login-div">

    <b-alert :show="ui.showError" class="mt-4" variant="danger">
      {{ ui.showErrorMessage }}
    </b-alert>
    <b-alert :show="ui.showSuccess" class="mt-5" variant="success">
      {{ $t('ChangePassword.success') }}
      <br/>
    </b-alert>
    <div v-show="ui.showSuccess" class="mt-4">
      <b-button
        :class="{ 'loading-ellipsis': isLoading }"
        :disabled="isLoading"
        class="btn-block"
        type="submit"
        variant="secondary">
        {{ this.$t('Connecting') }}
      </b-button>
    </div>


    <div v-if="!ui.showError && !ui.showSuccess">
      <h1 class="page-title mt-5 bold-text confirm-email">
        <chevron-left-icon class="cursor-pointer chevron-color" @click="backToLogin"/>
        {{ $t('ChangePassword.newPassword') }}
      </h1>
      <div class="mt-3">
        <p v-html="$t('ChangePassword.info', {mail: email})"></p>
      </div>

      <form ref="form" class="mt-4" @submit.stop.prevent="handleSubmit">
        <!-- New password -->
        <b-form-group
          :invalid-feedback="form.newPassword.invalidFeedback"
          :label="$t('NewPassword')"
          :state="form.newPassword.state"
          label-for="newPassword-input">
          <b-form-input
            id="newPassword-input"
            v-model="form.newPassword.value"
            :state="form.newPassword.state"
            autocomplete="off"
            required
            type="password">
          </b-form-input>
        </b-form-group>

        <div class="mt-4">
          <b-button
            :class="{ 'loading-ellipsis': isLoading }"
            :disabled="isLoading"
            class="btn-block"
            type="submit"
            variant="secondary">
            {{ isLoading ? $t('Connecting...') : $t('Validate') }}
          </b-button>

        </div>

      </form>
    </div>

  </div>
</template>

<script>

import api from '../../../services/api'

export default {

  name: 'ResetPasswordComponent',

  data() {
    return {
      isLoading: false,
      token: this.$route.params.token,
      userId: this.$route.params.userId,
      form: {
        newPassword: {
          value: null,
          state: null,
          invalidFeedback: null
        },

      },
      ui: {
        showSuccess: false,
        showError: false,
        showErrorMessage: ''
      },
      email: null
    }
  },

  emits: ['showLoginView', 'tokenExpired'],

  watch: {
    'ui.showErrorMessage': {
      immediate: true,
      handler(value) {
        if (value) {
          this.$emit('tokenExpired', true)
        }
      }
    }
  },
  mounted() {
    this.checkToken()
  },

  methods: {

    checkToken() {
      let data = new FormData()
      data.append('token', this.token)
      data.append('userId', this.userId)

      api({
        method: 'POST',
        url: `/forgotPassword/checkResetPasswordToken`,
        data: data
      })
        .then((response) => {
          this.email = response.data.email

        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.ui.showErrorMessage = this.$i18n.t('Login.error');
            this.ui.showError = true;
          }
          if (error.response.status === 403) {
            this.ui.showErrorMessage = this.$i18n.t(error.response.data.message);
            this.ui.showError = true;
          }
        })

    },

    handleSubmit() {
      if (!this.isFormValid()) {
        return
      }
      this.isLoading = true

      let formData = new FormData()
      formData.append('token', this.token)
      formData.append('userId', this.userId)
      formData.append('newPassword', this.form.newPassword.value.trim())

      api({
        method: 'POST',
        url: `/forgotPassword/resetPassword`,
        data: formData
      })
        .then(() => {
          this.ui.showSuccess = true
          this.ui.showError = false
          setTimeout(() => {
            this.isLoading = false;
            this.autoLogin()
          }, 3000);
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.ui.showErrorMessage = this.$i18n.t('Login.error')
            this.ui.showError = true
          }
          if (error.response.status === 403) {
            this.ui.showErrorMessage = this.$i18n.t(error.response.data.message)
            this.ui.showError = true
          }
        })
    },

    isFormValid() {
      let valid = this.$refs.form.checkValidity()
      if (!valid) {
        this.$refs.form.reportValidity()
        return false
      }
      if (this.form.newPassword.value == null || this.form.newPassword.value.trim() === '') {
        this.form.newPassword.state = false
        this.form.newPassword.invalidFeedback = this.$i18n.t('MandatoryField')
        return false
      } else if (this.form.newPassword.value.trim().length < 8) {
        this.form.newPassword.state = false
        this.form.newPassword.invalidFeedback = this.$i18n.t('Password.minlenght.error')
        return false
      }
      return true
    },

    async autoLogin() {
      let data = {
        username: this.email.trim(),
        password: this.form.newPassword.value.trim()
      }
      let formData = new FormData()
      formData.append('username', data['username'])
      formData.append('password', data['password'])

      await api({
        method: 'POST',
        url: '/authentication/beforeLogin',
        data: formData
      })
        .then(async (response) => {
          // login
          await this.$store.dispatch('LogIn', data)
            .then(async () => {
              this.ui.showError = false
              this.goToHome()
            })
            .catch((error) => {
              if (error.toString() === 'Locked') {
                this.ui.showErrorMessage = this.$i18n.t('Profile.forbidden.error')
                this.ui.showError = true
              }
            })
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.ui.showErrorMessage = this.$i18n.t('Login.error')
            this.ui.showError = true
          }
          if (error.response.status === 403) {
            this.ui.showErrorMessage = this.$i18n.t(error.response.data.message)
            this.ui.showError = true
            if (error.response.data.message === 'account.not.validated.error') {
              this.ui.showValidateAccountError = true
            }
          }
          if (error.response.status === 423) {
            this.ui.showErrorMessage = this.$i18n.t('account.locked.error')
            this.ui.showError = true
          }
          if (error.response.status === 500) {
            this.ui.showErrorMessage = this.$i18n.t('internal.server.error')
            this.ui.showError = true
          }
        })
    },


    backToLogin() {
      this.$emit('showLoginView')
    },

    goToHome() {
      if(this.$store.getters.isAgentImmo){
        this.$router.push({
          name: 'DashboardAgentImmo'
        })
      } else {
        this.$router.push({
          name: 'Dashboard'
        })
      }
    }

  }

}

</script>

<style scoped>
.chevron-color {
  color: var(--secondary-color)
}

@keyframes ellipsis {
  to {
    content: "\2026"; /* trois points */
  }
}

.loading-ellipsis:after {
  content: ".";
  animation: ellipsis 1s steps(3, end) infinite;
}

</style>



// WEBPACK FOOTER //
// src/views/auth/components/ResetPasswordComponent.vue